import { 
  STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING,
  STOCK_DICTIONARY_FETCH_TRANSLATION_SUCCESS,
  STOCK_DICTIONARY_FETCH_TRANSLATION_FAILURE,
} from '../constants'


export function reducer(state, action){
  switch (action.type){
    case STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING:
      return {
        ...state,
        getDictionaryOptionsPending: true,
        dictionaryOptions: null,
        dictionarySelectedTranslation: null,
      }
    case STOCK_DICTIONARY_FETCH_TRANSLATION_SUCCESS:
      return {
        ...state,
        getDictionaryOptionsPending: false,
        dictionaryOptions: action.data.options,
        dictionarySelectedTranslation: action.data.dictionarySelectedTranslation,
      }
    case STOCK_DICTIONARY_FETCH_TRANSLATION_FAILURE:
      return {
        ...state,
        getDictionaryOptionsPending: false,
        getDictionaryOptionsError: action.data.error,
      }
    default: return state
  }
}